import React, { h } from "preact";
import Button, { IButtonProps } from "./Button";
import {
  VERTICAL_HEIGHT,
  VERTICAL_WIDTH,
  VERTICAL_WIDTH_EXTENDED,
  VERTICAL_Y,
} from "./index";

const RightButton: React.FunctionalComponent = (
  props: React.RenderableProps<IButtonProps & { extendToOuterEdge: boolean }>,
): JSX.Element => (
  <Button
    rectProps={{
      x: props.extendToOuterEdge ? "366" : "397.5",
      y: VERTICAL_Y,
      width: props.extendToOuterEdge ? VERTICAL_WIDTH_EXTENDED : VERTICAL_WIDTH,
      height: VERTICAL_HEIGHT,
      transform: "rotate(90 397.5 32.5)",
      fill: "#999DA2",
      stroke: "#999DA2",
    }}
    pathProps={
      props.selected
        ? {
            d: "M4.37114e-08 11.5 L16 11.5",
            fill: "#000A17",
            stroke: "#000A17",
            x: "24",
            y: "24",
            transform: "translate(370,75)",
          }
        : {
            d: "M8 8V16H9V8H16V7L9 7V0H8V7L0 7V8H8Z",
            fill: "#000A17",
            x: "24",
            y: "24",
            transform: "translate(370,79)",
          }
    }
    {...props}
  />
);

export default RightButton;
